import React from 'react'
import PropTypes from 'prop-types'
import { withSearch } from '@elastic/react-search-ui'
import { SEARCH_RESULT } from '../../../utils/types'
import STVResult from '../STVResult'
import processResults from '../processResults'
import { resultsStyles } from './styles'
import { sendGoogleTagEvent } from '../../../utils/google-tag-manager-helpers'

export const STVResults = ({
  className,
  clickThroughTags,
  results,
  shouldTrackClickThrough,
  searchTerm,
  ...rest
}) => {
  if (searchTerm) {
    sendGoogleTagEvent('search', { search_term: searchTerm })
  }
  return (
    <ul
      className="sui-results-container"
      {...rest}
    >
      {results.map(result => (
        <STVResult
          key={result?.id?.raw}
          result={result}
          clickThroughTags={clickThroughTags}
          shouldTrackClickThrough={shouldTrackClickThrough}
        />
      ))}
      <style jsx>{resultsStyles}</style>
    </ul>
  )
}

STVResults.propTypes = {
  className: PropTypes.string,
  clickThroughTags: PropTypes.arrayOf(PropTypes.string),
  shouldTrackClickThrough: PropTypes.bool,
  results: PropTypes.arrayOf(SEARCH_RESULT).isRequired,
  searchTerm: PropTypes.string.isRequired,
}

STVResults.defaultProps = {
  className: '',
  clickThroughTags: [],
  shouldTrackClickThrough: true,
}

export default withSearch(({ results }) => ({ results: processResults(results) }))(STVResults)
